import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationColumnRemovedKeys } from './use-v2-reservationcolumn-find-removed-query'
import { reservationColumnKeys } from '@/composables/queries/reservationcolumn/use-reservation-column-find-query'

type CreateReservationColumnBody = Parameters<typeof apiClient.v2.apiV2ReservationcolumnElCreate>[0]

const createReservationColumn = async (body: CreateReservationColumnBody) => {
  const { data } = await apiClient.v2.apiV2ReservationcolumnElCreate(body)
  return checkApiResponse(data)
}

export const useV2ReservationColumnCreateMutation = ({ options }: MutationComposableParams<unknown, CreateReservationColumnBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: createReservationColumn,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationColumnRemovedKeys.all })
        queryClient.invalidateQueries({ queryKey: reservationColumnKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
